export const getDateWeek = (date) => {
  const currentDate = typeof date === 'object' ? date : new Date();
  const januaryFirst = new Date(currentDate.getFullYear(), 0, 1);
  const daysToNextMonday = januaryFirst.getDay() === 1 ? 0 : (7 - januaryFirst.getDay()) % 7;
  const nextMonday = new Date(currentDate.getFullYear(), 0, januaryFirst.getDate() + daysToNextMonday);

  return currentDate < nextMonday ? 52 : Math.ceil((currentDate.getTime() - nextMonday.getTime()) / (24 * 3600 * 1000) / 7);
};

export const groupBy = (xs, key) => {
  return xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

// export const isEmpty = (obj) => {
//   for (const prop in obj) {
//     if (Object.hasOwn(obj, prop)) {
//       return false;
//     }
//   }
//   return true;
// };